export default ({ app, $axios, store, req }, inject) => {

  inject('api', () => {
      const defaultOptions = {
          baseURL: process.env.SPORTSBOOK_API + '/',
          headers: {
              'Content-Type': 'application/json',
              'bookmaker': process.env.BOOKMAKER,
          },
      };

      // Create instance
      let instance = app.$axios.create(defaultOptions);
      instance.interceptors.request.use(function (config) {
        if (process.client) {
          config.headers.jwt =  localStorage.getItem('jwt');
        }
        return config;
      });

      return instance
  })

  inject('infoapi', () => {
    const defaultOptions = {
      baseURL: process.env.SPORTSBOOK_API + '/',
      headers: {
        'Content-Type': 'application/json',
        'bookmaker': process.env.BOOKMAKER,
      },
    };

    // Create instance
    let instance = app.$axios.create(defaultOptions);
    instance.interceptors.request.use(function (config) {
      if (process.client) {
        config.headers.jwt =  localStorage.getItem('jwt');
      }
      return config;
    });

    return instance
  })  
    
  inject('cached', () => {
      const defaultOptions = {
          baseURL: app.$config.SPORTSBOOK_CDN + '/',
          headers: {
              'Content-Type': 'application/json',
              'bookmaker': process.env.BOOKMAKER,
          },
      };
      // Create instance
      let instance = app.$axios.create(defaultOptions);
      instance.interceptors.request.use(function (config) {
        if (process.client) {
          config.headers.jwt =  localStorage.getItem('jwt');
        }
        return config;
      });

      return instance
  })

  inject('content', () => {
      const defaultOptions = {
          baseURL: app.$config.CONTENT_API + '/api/content',
          headers: {
              'Content-Type': 'application/json',
              //'jwt': localStorage.getItem('jwt'),
              'bookmaker': process.env.BOOKMAKER,
          },
      };

      // Create instance
      let instance = app.$axios.create(defaultOptions);
      instance.interceptors.request.use(function (config) {
          //config.headers.jwt =  localStorage.getItem('jwt');
          config.headers.bookmaker = process.env.BOOKMAKER;
          return config;
        });
      return instance
  })

    inject('new_cms', () => {

        const logToGraylog = (message, context = {}) => {
            try {
                app.$axios.post(`${app.$config.NEW_CMS_URL}/api/_front-log`, {
                    user_id: store.state.auth?.user?.id || null,
                    message: message,
                    context: {
                        ...context,
                        url: req?.url || '',
                        userAgent: req?.headers?.['user-agent'] || '',
                        userId: store.state.auth?.user?.id || null,
                    }
                }, {
                    headers: {
                        'X-TOKEN': app.$config.LOG_SECRET
                    }
                })
            } catch (e) {
                // silent fail
            }
        }

        const instance = app.$axios.create({
            baseURL: app.$config.NEW_CMS_URL,
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
            },
        })

        instance.interceptors.request.use((config) => {
            let jwt = ''

            if (process.server) {
                const cookieParser = require('cookie')
                const cookieHeader = req?.headers?.cookie || ''
                try {
                    const cookies = cookieParser.parse(cookieHeader)
                    jwt = cookies.jwt || ''
                } catch (err) {
                    logToGraylog('Failed to parse cookies', { error: err.message })
                }
                if (!jwt) {
                    jwt = store.state.auth.jwt || ''
                }

            } else if (process.client) {
                jwt = app.$cookies.get('jwt') || ''
                if (!jwt) {
                    jwt = store.state.auth.jwt || ''
                }
            }

            config.headers.jwt = jwt
            return config
        })

        return instance
    })
  
  inject('cms', () => {
      const defaultOptions = {
          baseURL: app.$config.CMS_URL + '/api',
          headers: {
              'Content-Type': 'application/json',
          },
      };
      let instance = app.$axios.create(defaultOptions);
      return instance
  })

  inject('cmscasino', () => {
    const defaultOptions = {
      baseURL: app.$config.CONTENT_777_API + '/api/common/content',
      headers: {
        'Content-Type': 'application/json',
      },
    };
    return app.$axios.create(defaultOptions)
  })

  inject("nbsapi", () => {
        const defaultOptions = {
        baseURL: app.$config.NBS_API + '/tournaments',
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json',
            bookmaker: process.env.BOOKMAKER,
        },
        };

        // Create instance
        let instance = app.$axios.create(defaultOptions);
        instance.interceptors.request.use(function (config) {
        //config.headers.jwt =  localStorage.getItem('jwt');
        config.headers.bookmaker = process.env.BOOKMAKER;
        return config;
        });
        return instance;
    });
}
